import { cn } from "@utils";

export const TabGroup = ({ children, className, variant = "default" }) => {
  return (
    <div className={cn("my-8 text-sm font-medium", className)}>
      <div
        aria-label="Tabs"
        className={cn(
          "-mb-px flex",
          variant === "pill" &&
            "gap-0.5 rounded-lg bg-white border border-zinc-200 shadow-sm p-0.5",
        )}
      >
        {children}
      </div>
    </div>
  );
};

const defaultStyles = {
  base: "flex items-center flex-1 justify-center border-2 h-10 text-center select-none border-l-0 border-r-0 first:border-l-2 last:border-r-2 first:rounded-tl-lg first:rounded-bl-lg last:rounded-tr-lg last:rounded-br-lg",
  active: "border-2 border-primary text-primary",
  inactive:
    "border-zinc-300 text-zinc-500 hover:text-zinc-700 hover:bg-zinc-100",
};

const androidStyles = {
  base: "flex items-center flex-1 justify-center h-10 text-center select-none transition-colors px-6",
  active: "text-primary border-b-2 border-primary",
  inactive: "text-zinc-500 hover:text-zinc-700 border-b-2 border-transparent",
};

const pillStyles = {
  base: "flex items-center flex-1 justify-center h-6 px-2 rounded-md text-center select-none transition-all cursor-pointer",
  active: "bg-zinc-100 text-zinc-900",
  inactive: "text-zinc-500 hover:text-zinc-700",
};

const variantMap = {
  default: defaultStyles,
  android: androidStyles,
  pill: pillStyles,
};

export const Tab = ({
  active,
  onClick,
  children,
  variant = "default",
  className,
}) => {
  const styles = variantMap[variant] || defaultStyles;

  return (
    <div
      onClick={onClick}
      role="button"
      className={cn(
        styles.base,
        active ? styles.active : styles.inactive,
        className,
      )}
    >
      {children}
    </div>
  );
};
